import request from '../request';
import { AvatarsAPI } from './api-types';
import { getAvatarURL } from './helpers';
import urls from './urls';

export async function fetchAvatars(payload: AvatarsAPI.FetchAvatarsRequest) {
  const { avatarId: _avatarId, bucket, baseURL } = payload;

  const avatarIds: MongoId[] = Array.of(_avatarId);
  const response = await request.post<AvatarsAPI.FetchAvatarsResponse>(
    urls.getAvatar,
    { avatarIds },
    { baseURL }
  );

  const { links } = response.data;
  const avatars: Record<MongoId, AvatarURL> = {};

  for (const avatarId in links) {
    if (Object.prototype.hasOwnProperty.call(links, avatarId)) {
      const fileName = links[avatarId];
      avatars[avatarId] = getAvatarURL(bucket, fileName);
    }
  }

  return avatars;
}
